import React, { useReducer, useEffect } from "react";

import DatePickeur from "./DatePickeur";
import MultiSelekt from "./MultiSelekt";
import classX from "classnames";
import PropTypes from "prop-types";

import { validate } from "../../Tools/validators";
import "./Input.scss";

const reducer = (state, action) => {
  switch (action.type) {
    case "CHANGE":
      return {
        ...state,
        value: action.valeur,
        isValid: validate(action.valeur, action.validators),
      };
    case "TOUCH":
      return {
        ...state,
        isTouched: true,
      };
    default:
      return StaticRange;
  }
};

const Input = (props) => {
  const initialState = {
    value: props.initialValue || "",
    isTouched: false,
    isValid: props.initialValid || false,
  };

  const [inputState, dispatch] = useReducer(reducer, initialState);

  const { id, onInput } = props;
  const { value, isValid } = inputState;

  useEffect(() => {
    onInput(id, value, isValid);
  }, [id, value, isValid, onInput]);

  const changeHandler = (event) => {
    dispatch({
      type: "CHANGE",
      valeur: event.target.value,
      validators: props.validators,
    });
  };

  const dateChangeHandler = (value) => {
    dispatch({
      type: "CHANGE",
      valeur: value,
      validators: props.validators,
    });
  };

  const multiSelectChangeHandler = (value) => {
    dispatch({
      type: "CHANGE",
      valeur: value,
      validators: props.validators,
    });
  };


  const touchHandler = () => {
    dispatch({
      type: "TOUCH",
    });
  };

  const emBeddedLabelCssClass = classX({
    "input-label": true,
    "input-label-login": props.appearance === appearances.login,
    "input-label-data": props.appearance === appearances.data,
  });

  const emBeddedInputCssClass = classX({
    "input-element": true,
    "input-element-login": props.appearance === appearances.login,
    "input-element-data": props.appearance === appearances.data,
  });

  let element;
  switch (props.element) {
    case "input":
      element = (
        <input
          id={props.id}
          type={props.type}
          placeholder={props.placeholder}
          value={inputState.value}
          onBlur={touchHandler}
          onChange={changeHandler}
          style={{ width: `${props.width + "px"}` }}
        />
      );
      break;
    case "textarea":
      element = (
        <textarea
          id={props.id}
          rows={props.rows || 3}
          value={inputState.value}
          onChange={changeHandler}
          onBlur={touchHandler}
        />
      );
      break;
    case "date":
      element = (
        <DatePickeur
          value={inputState.value}
          onChange={dateChangeHandler}
          onBlur={touchHandler}
        />
      );
      break;
      case "multiselect":
        element = (
          <MultiSelekt
            id={props.id}
            source={props.source}
            optionLabel ={props.optionLabel}
            optionId = {props.optionId}
            prompt="selection..."
            value={inputState.value}
            width={props.width}
            onChange={multiSelectChangeHandler}
            ></MultiSelekt>
        );
        break;
    default:
      element = (
        <input
          id={props.id}
          type={props.type}
          placeholder={props.placeholder}
          value={inputState.value}
          onBlur={touchHandler}
          onChange={changeHandler}
        />
      );
  }

  return (
    <React.Fragment>
      <div
        className={`form-control ${
          !inputState.isValid && inputState.isTouched && "form-control--invalid"
        }`}
      >
        <div className={emBeddedLabelCssClass}>
          <label htmlFor={props.id}>{props.label}</label>
        </div>
        <div className={emBeddedInputCssClass}>{element}</div>
      </div>
      {!inputState.isValid && inputState.isTouched && (
        <div className="input-validation">{props.errorText}</div>
      )}
    </React.Fragment>
  );
};

const appearances = {
  login: "login",
  data: "data",
  standard: "standard",
};

Input.prototypes = {
  appearance: PropTypes.oneOf(Object.keys(appearances)),
};

Input.appearances = appearances;

export default Input;
